// src/hooks/useAuthService.ts
import { useState, useEffect } from 'react';
import { authService } from '../services/AuthService';

export function useAuthService() {
  const [authState, setAuthState] = useState({
    user: authService.getCurrentUser(),
    isAuthenticated: authService.isAuthenticated(),
    loading: authService.isLoading()
  });
  
  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged(state => {
      setAuthState(state);
    });
    
    return unsubscribe;
  }, []);
  
  return {
    user: authState.user,
    isAuthenticated: authState.isAuthenticated,
    isLoading: authState.loading,
    login: authService.login.bind(authService),
    loginWithProvider: authService.loginWithProvider.bind(authService),
    logout: authService.logout.bind(authService),
    checkAuth: authService.checkAuth.bind(authService)
  };
}